export type CacheKey = {
  url: string;
  params?: object;
};

export class ResponseCache<T extends object> {
  private static stringify({ url, params }: CacheKey) {
    const strParams = params ? JSON.stringify(params) : '';
    return `${url}|${strParams}`;
  }

  private readonly cache: Map<string, T | null>;

  constructor() {
    this.cache = new Map();
  }

  async getOrSave(key: CacheKey, getValue: () => T | null): Promise<T | null> {
    const value = this.get(key);
    if (value === undefined) {
      return this.set(key, await getValue());
    }
    return value;
  }

  get(key: CacheKey): T | null | undefined {
    return this.cache.get(ResponseCache.stringify(key));
  }

  set(key: CacheKey, value: T | null): T | null {
    this.cache.set(ResponseCache.stringify(key), value);
    return value;
  }
}
